/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./danMaku.vue?vue&type=template&id=5c169632"
import script from "./danMaku.vue?vue&type=script&lang=js"
export * from "./danMaku.vue?vue&type=script&lang=js"
import style0 from "./danMaku.vue?vue&type=style&index=0&id=5c169632&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports